export default __webpack_public_path__ + "static/media/11A.050-SCRUBBED.708d2763.png";